// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__LaEFB","question":"Question_question__3JrYu","description":"Question_description__3JcxG"};